import { ChangeEvent, useState } from 'react'
import { FaChevronDown } from 'react-icons/fa6'

import { Input } from '../../../components/Input'
import { cn } from '../../../libs/tailwindMerge'

interface CitiesDashboardSelectProps {
  handleTypeFilterCities: (value: string) => void
  cities: {
    id: string;
    name: string;
  }[]
  onSelectCity: (id: string) => void
  selectedCity: string | undefined
}

export function CitiesDashboardSelect({ handleTypeFilterCities, cities, onSelectCity, selectedCity }: CitiesDashboardSelectProps) {
  const [isOpen, setIsOpen] = useState(false)

  function toggleOpen() {
    setIsOpen(open => !open)
  }
  return (
    <main className="flex flex-col w-full overflow-hidden rounded-md">
      <button
        className={cn(
          'flex w-full bg-white py-3 px-4 justify-between items-center',
          isOpen && 'border-b',
          !isOpen && 'rounded-b-md',
        )}
        onClick={toggleOpen}
      >
        <h2 className="text-lg font-semibold">Cidade</h2>
        <div>
          <FaChevronDown
            className={cn(
              'transition-transform',
              isOpen && 'rotate-180',
            )}
            aria-hidden="true"
          />
        </div>
      </button>

      <section
        className={cn(
          'origin-top bg-white transition duration-100 focus:outline-none p-4',
          !isOpen && 'hidden',
        )}
      >
        <Input
          placeholder="Pesquisar cidade..."
          className=""
          onChange={(e: ChangeEvent<HTMLInputElement>) => handleTypeFilterCities(e.target.value)}
        />
        <div className="mt-4 max-h-[150px] overflow-y-auto">
          {cities.map(item => (
            <button
              key={item.id}
              type="button"
              onClick={() => onSelectCity(item.id)}
              className={cn(
                'flex w-full py-3 px-2 border-b transition-all last:border-none hover:bg-slate-100',
                selectedCity && selectedCity !== item.id &&
                  'opacity-30',
              )}
              title={item.name}
            >
              <span className="font-semibold">{item.name}</span>
            </button>
          ))}
        </div>
      </section>
    </main>
  )
}
